<template>
  <v-card
    height="186"
    min-width="310"
    max-width="600"
    class="px-4 pb-2 d-flex flex-column board-card"
    outlined
    data-tourid="boards-board-card"
    :loading="loading"
    :ripple="false"
    :to="{ name: 'board', params: { boardId: board.id } }"
  >
    <v-card-title class="mt-4 ma-0 pa-0 mb-2" style="word-break: break-word">
      <div class="d-flex justify-space-between align-start" style="width: 100%">
        <div>
          <p v-snip="1" class="blue-grey--text text--darken-2 caption ma-0">
            {{ createdByLabel }}
          </p>
          <p
            class="pa-0 ma-0 mt-1 blue-grey--text text--darken-3 font-size-16 font-weight-600"
            style="line-height: 20px;"
            v-snip="2"
          >
            {{ board.name }}
          </p>
        </div>

        <v-btn
          x-small
          icon
          plain
          class="me-n1"
          :ripple="false"
          :class="{ 'show-hover': !board.isPinnedByMe }"
          @click.prevent="$emit('pin', board.id)"
        >
          <v-icon size="16" color="blue">
            {{ pinIcon }}
          </v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <div class="flex-grow-1">
      <p
        v-if="board.description"
        class="ma-0 pa-0 blue-grey--text text--darken-1 caption mb-3"
        v-snip="3"
      >
        {{ board.description }}
      </p>
    </div>
    <v-card-actions class="ma-0 pa-0 d-flex justify-space-between">
      <p
        class="ma-0 pa-0 blue-grey--text text--darken-3 caption"
        style="line-height: 32px"
      >
        {{ $t('boards.columns_count', { count: board.columnsCount }) }}
      </p>
      <div class="d-flex">
        <div v-for="(action, index) in actions" :key="action.id">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="show-hover"
                small
                icon
                color="blue-grey darken-1"
                :class="{ 'mb-1': index < 1 }"
                @click.prevent="$emit(action.id, board.id)"
              >
                <v-icon size="16">{{ action.icon }}</v-icon>
              </v-btn>
            </template>
            {{ action.text }}
          </v-tooltip>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import userMixin from '@/mixins/userMixin.vue'

export default {
  name: 'BoardCard',

  mixins: [userMixin],

  props: {
    loading: Boolean,
    board: { required: true, type: Object },
  },

  computed: {
    ...mapGetters(['accountId']),

    isBoardOwner() {
      return (
        (this.board?.createdBy?.id ?? this.board?.createdBy) === this.accountId
      )
    },

    createdByLabel() {
      return this.$t(
        this.isBoardOwner
          ? this.$t('common.created_by_me')
          : this.$t('common.created_by_user', {
              userName: this.getFullName(this.board.createdBy),
            })
      )
    },

    pinIcon() {
      return this.board.isPinnedByMe ? 'mdi-pin' : 'mdi-pin-outline'
    },

    actions() {
      return _.compact([
        this.isBoardOwner && {
          id: 'share',
          icon: 'mdi-share-variant-outline',
          text: this.$t('common.button.share'),
        },
        {
          id: 'copy',
          icon: 'mdi-link-variant',
          text: this.$t('common.copy_link'),
        },
        !this.isBoardOwner && {
          id: 'unfollow',
          icon: 'mdi-account-minus-outline',
          text: this.$t('common.unfollow'),
        },
        {
          id: 'duplicate',
          icon: 'mdi-content-copy',
          text: this.$t('common.button.duplicate'),
        },
        this.isBoardOwner && {
          id: 'delete',
          icon: 'mdi-trash-can-outline',
          text: this.$t('common.button.delete'),
        },
      ])
    },
  },
}
</script>
<style lang="scss">
.board-card:hover {
  background-color: $color-blue-grey-lighten3;
  .show-hover {
    visibility: visible !important;
  }
}
.show-hover {
  visibility: hidden !important;
}
</style>
